export enum EntityOwnerEntityTypes {
  user = 'User',
  policy = 'Policy',
  coverage = 'Coverage',
  customer = 'customer',
}

export enum EntityOwnerOwnerTypes {
  user = 'User',
  agent = 'agent',
}
